import {
  Flex,
  SegmentedControl,
  SegmentedControlProps,
  Text,
} from "@mantine/core";
import { useTranslation } from "react-i18next";

interface IProps extends SegmentedControlProps {
  radius?: string;
  label?: string;
}

const SegmentControlRounded = ({ radius, label, ...props }: IProps) => {
  const { t } = useTranslation();
  return (
    <Flex direction={"column"} gap={8}>
      {!!label ? (
        <Text fw={600} fz="14px" lh="155%">
          {t(label)}
        </Text>
      ) : null}
      <SegmentedControl
        {...props}
        data={props.data.map((item: any) => ({
          label: t(item.label),
          value: item.value,
        }))}
        radius={16}
        size="56px"
        styles={{
          root: {
            borderRadius: !!radius ? radius : "50px",
          },
        }}
      />
    </Flex>
  );
};
export default SegmentControlRounded;
